(function () {
  function initialize(scope) {
    if (!window.theme || !theme.AjaxProduct) return;
    if (scope.matches?.('form[data-sonee-tile-cart]') && !scope.dataset.cartReady) {
      scope.dataset.cartReady = 'true';
      new theme.AjaxProduct(scope);
    }
    scope.querySelectorAll?.('form[data-sonee-tile-cart]:not([data-cart-ready])').forEach(function (form) {
      form.dataset.cartReady = 'true';
      new theme.AjaxProduct(form);
    });
  }

  function start() {
    initialize(document);
    new MutationObserver(function (records) {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node.nodeType === 1) initialize(node);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
